import React from "react";
import dynamic from "next/dynamic";
import Logos from "../components/home/logos";
import AppDetails from "@components/home/appDetails";
import TestimonialBar from "@components/home/testimonialBar";
import FeaturesTall from "../components/home/featuresTall";
import CTA from "@components/cta";
import Footer from "../components/home/footer";
import FeaturesLeft from "../components/home/featuresLeft";
import FeaturesRight from "../components/home/featuresRight";
// import Head from 'next/head'
import Blog from "../components/home/blog";
import HowItWorks from "@/components/about/HowItWorks";
import Seo from "@/components/seo";

const HeroNoSSR = dynamic(() => import("../components/home/hero"), { ssr: false });

const Home = () => {
  return (
    <>
      <Seo
        title="Pinto Financial | Your Small Business CFO"
        description="Pinto provides financial tools and support to help make your business profitable. Bookkeeping. Forecasting. Reporting. Back Office."
      />
      <div className="">
        <HeroNoSSR />
        <Logos />
        <AppDetails />
        <TestimonialBar />
        <div className="bg-white px-6 py-24 sm:py-32 lg:px-8">
          <div className="mx-auto max-w-7xl text-center">
            <h2 className="text-4xl tracking-tight text-gray-900 sm:text-6xl">Learn How It Works</h2>
            <p className="mt-6 text-lg leading-8 text-gray-600"></p>
            <iframe
              className="mt-24 mx-auto"
              src="https://www.loom.com/embed/576378a8a07b4f5e876b72c87d2a0f6f"
              frameborder="0"
              webkitallowfullscreen
              mozallowfullscreen
              allowfullscreen
              style={{ height: "600px", width: "800px" }}
            ></iframe>
          </div>
        </div>
        <FeaturesLeft />
        <FeaturesRight />
        <HowItWorks />
        {/*<FeaturesTall />*/}
        {/*<Blog />*/}
        <CTA />
        <Footer />
      </div>
    </>
  );
};

export default Home;
